export const KEYWORDS_LABEL = "activation.widget.topics.topic.keywords.label.text";
export const KEYWORDS_TOOLTIP = "activation.widget.topics.topic.keywords.tooltip.text";

export const SHARE_TOOLTIP = "activation.widget.topics.share.tooltip.text";
